import React, { Component } from "react";
import { connect } from "react-redux";
import { ReleaseApi } from "services/release";
import { Utils } from "services/utils";
import Policies from "sub_components/Layout/Footer/Components/Policies";
import Eula from "sub_components/Layout/Footer/Components/Eula";
import ReleaseNotes from "sub_components/Layout/Footer/Components/ReleaseNotes/ReleaseNotes";
import compareDesc from "date-fns/compareDesc";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const dcblox_logo = `${CDN_URL}common/dcblox-logo-lg.svg`;

class Footer extends Component {
  constructor(props) {
    super(props);
    this.releaseApi = new ReleaseApi();
    this.state = {
      showModal: false,
      releases: null,
      releasesError: null,
      unviewedReleases: null,
    };
  }

  componentDidMount() {
    this.requestReleases();
  }

  getUnviewedReleases = (releases) => {
    let sortedReleases = releases;
    sortedReleases = sortedReleases.sort((a, b) =>
      compareDesc(new Date(a.publish_date), new Date(b.publish_date))
    );
    sortedReleases = sortedReleases.slice(0, 6);
    return sortedReleases.filter((release) => release.viewed === null);
  };

  requestReleases = () => {
    this.setState({ releases: null });
    const { auth_status } = this.props;
    const {
      user: { id },
    } = auth_status;

    return this.releaseApi
      .getAllReleases(id)
      .then((response) => {
        const { releases } = response.data;
        if (!Utils.isValidResponse(response)) {
          this.setState({ releasesError: response.data.error });
        } else {
          const unviewedReleases = this.getUnviewedReleases(releases);
          const unviewedReleasesLength =
            unviewedReleases.length !== 0 ? unviewedReleases.length : null;
          this.setState({ releases, unviewedReleases: unviewedReleasesLength });
        }
      })
      .catch((error) => {
        this.setState({ releasesError: error });
      });
  };

  onMouseOver = (component) => {
    const selectedComponent = document.querySelector(component);

    if (selectedComponent) {
      setTimeout(() => {
        selectedComponent.classList.add("selected");
      }, 2000);
    }
  };
  onMouseOut = (component) => {
    const expandComponent = document.querySelector(component);

    if (expandComponent) {
      setTimeout(() => {
        expandComponent.classList.remove("selected");
      }, 2000);
    }
  };

  render() {
    const { releases, unviewedReleases } = this.state;
    const { site, breakpoint, auth_status } = this.props;

    return (
      <footer className="footerContainer ">
        <div className="left-container">
          <a
            href="https://www.dcblox.com"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="footer-logo"
          >
            <img src={dcblox_logo} />
          </a>
        </div>
        <div className="middle-container">
          <div
            className="policies-wrapper"
            onMouseOut={() => this.onMouseOut(".policies-wrapper")}
            onMouseOver={() => this.onMouseOver(".policies-wrapper")}
          >
            <div className="title-wrapper">
              <div className="text footer50">TERMS/POLICIES</div>
              {/* <div className='notifications'>
								<div className='amount footer11'>1</div>
								<img src={notificationDiamond} />
							</div> */}
            </div>
            <div className="policy-reveal">
              <Policies site={site} breakpoint={breakpoint} />
            </div>
          </div>
          <div
            className="eula-block-wrapper"
            onMouseOut={() => this.onMouseOut(".eula-block-wrapper")}
            onMouseOver={() => this.onMouseOver(".eula-block-wrapper")}
          >
            <div className="title-wrapper">
              <div className="text footer50">Eula</div>
              {/* <div className='notifications'>
								<div className='amount footer11'>1</div>
								<img src={notificationDiamond} />
							</div> */}
            </div>
            <div className="eula-reveal">
              <Eula site={site} breakpoint={breakpoint} />
            </div>
          </div>
          <div
            className="release-notes-wrapper"
            onMouseOut={() => this.onMouseOut(".release-notes-wrapper")}
            onMouseOver={() => this.onMouseOver(".release-notes-wrapper")}
          >
            <div className="title-wrapper">
              <div className="text footer50">Release Notes</div>
              {unviewedReleases && (
                <div className="notifications footer11">
                  {Utils.getNotificationIcon(
                    site.module,
                    unviewedReleases > 9 ? "!" : unviewedReleases,
                    breakpoint
                  )}
                </div>
              )}
            </div>
            <div className="release-notes-reveal">
              <ReleaseNotes
                site={site}
                releases={releases}
                unviewedReleases={unviewedReleases}
                breakpoint={breakpoint}
                auth_status={auth_status}
                refreshReleaseNotes={this.requestReleases}
              />
            </div>
          </div>
        </div>
        <div className="right-container">
          <a
            href="https://www.dcblox.com/support/"
            target="_blank"
            rel="noreferrer noopener"
          >
            <div className="text footer30">Support</div>
            <div className="number footer60">877.590.1684</div>
          </a>
        </div>
      </footer>
    );
  }
}

function mapStateToProps(state) {
  return {
    site: state.site_tracking,
    auth_status: state.auth_status,
  };
}

export default connect(mapStateToProps, null)(Footer);
